<template>
  <li class="flex flex-col">
    <a
      :href="`${env.BASE_URL}/${result.uri}`"
      class="wc-focus group bg-gray-100 rounded-2xl pt-4 px-6 pb-6 flex flex-col gap-y-4 size-full"
    >
      <div>
        <h2
          class="body-lg font-bold mb-2"
          v-text="result.title"
        />
        <p>
          <span v-text="`CE: ${result.ce_credit}`" />
          &middot;
          <span v-text="`${result.webinar_length} minutes`" />
        </p>
      </div>
      <div class="flex gap-6 mt-auto items-center justify-between">
        <span
          class="body-lg font-bold"
          v-text="formatMoney(result.price)"
        />
        <span class="link no-underline flex gap-x-1 items-center group-hover:underline group-hover:underline-offset-2">
          <span v-text="'View Details'" />
          <span
            class="sr-only"
            v-text="` about ${result.title}`"
          />
          <IconArrowRight
            class="shrink-0"
            :size="24"
            aria-hidden="true"
          />
        </span>
      </div>
    </a>
  </li>
</template>

<script lang="ts" setup>
import { env } from '@js/utils/env'

import { AisHit } from '@js/types/search/AisHit'
import { IconArrowRight } from '@tabler/icons-vue'

defineOptions({
  name: 'WebinarSearchResult',
})

defineProps<{
  result: AisHit
}>()

const formatMoney = (value: number) => new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
}).format(value)
</script>
